function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { cssStringToObject, get } from '../../utils/utils';
import { getImageComputedProperties, getImageSrc, getMaskBBox } from '../../utils/imageUtils';
import { getScreenHeight, setAttributes, setStyle } from '../../utils/domUtils';
import biEvents from './bi/events';

function getDefaultStyles(style) {
  var _style = style,
      width = _style.width,
      height = _style.height,
      styleWithoutDimensions = _objectWithoutPropertiesLoose(_style, ["width", "height"]); // eslint-disable-line no-unused-vars


  var stylesWithValue = {};

  for (style in styleWithoutDimensions) {
    if (styleWithoutDimensions[style] !== '') {
      stylesWithValue[style] = styleWithoutDimensions[style];
    }
  }

  return stylesWithValue;
}

function getContainerStyle(style, opacity) {
  var styleWithoutDefaults = getDefaultStyles(style);

  if (typeof opacity === 'number') {
    styleWithoutDefaults.opacity = opacity;
  }

  return styleWithoutDefaults;
}

function sendBiEvent(biService, envConsts, imageInfo, imageToLoad, imageComputedProperties) {
  // should send Bi Event if we are on viewer, url includes upscale value lg_
  var upscaleMatcher = /,lg_(\d)/;
  var upscaleResult = imageComputedProperties.uri.match(upscaleMatcher);
  var shouldSendBiEvent = envConsts.isViewerMode && imageComputedProperties.uri !== imageToLoad.currentSrc && upscaleResult;

  if (shouldSendBiEvent) {
    biService.reportBI(biEvents.IMAGE_UPSCALING, {
      originalWidth: imageInfo.imageData.width,
      originalHeight: imageInfo.imageData.height,
      targetWidth: Math.round(imageInfo.containerWidth),
      targetHeight: Math.round(imageInfo.containerHeight),
      upscaleMethod: upscaleResult[1] === '1' ? 'classic' : 'super',
      devicePixelRatio: Math.floor(envConsts.devicePixelRatio * 100),
      url: imageToLoad.src
    });
  }
}

function measure(id, measures, domNodes, _ref) {
  var containerId = _ref.containerId,
      isSvgImage = _ref.isSvgImage,
      isSvgMask = _ref.isSvgMask;
  var imageNode = domNodes.image;

  if (!imageNode) {
    return;
  }

  var imgSrc = getImageSrc(imageNode, isSvgImage);
  var hasBgScrollEffect = domNodes[id].getAttribute('data-has-bg-scroll-effect') === 'true';
  measures.width = hasBgScrollEffect ? domNodes[containerId].offsetWidth : domNodes[id].offsetWidth;
  measures.height = domNodes[id].offsetHeight;
  measures.containerTop = domNodes[containerId].offsetTop;
  measures.isZoomed = domNodes[id].getAttribute('data-image-zoomed');
  measures.isSvgImage = isSvgImage;
  measures.imgSrc = imgSrc;
  measures.containerId = containerId;
  measures.renderedStyles = domNodes[id].getAttribute('data-style');
  measures.screenHeight = getScreenHeight();
  measures.boundingRect = domNodes[id].getBoundingClientRect();

  if (isSvgMask) {
    measures.bBox = getMaskBBox(domNodes.maskSvg);
  }
}

function patch(id, measures, domNodes, imageInfo, services, envConsts, loadImage) {
  var style = cssStringToObject(measures.renderedStyles);
  var imageData = imageInfo.imageData;
  var extendedImageInfo = Object.assign({}, imageInfo, {
    containerWidth: measures.isZoomed ? imageData.width : measures.width,
    containerHeight: measures.isZoomed ? imageData.height : measures.height,
    displayMode: imageData.displayMode
  });
  var imageComputedProperties;

  if (measures.isSvgImage) {
    imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, 'svg');
    setAttributes(domNodes.svg, measures.isZoomed ? imageComputedProperties.attr.container : {});
  } else {
    imageComputedProperties = getImageComputedProperties(extendedImageInfo, envConsts, 'img');
    var imageStyle = get(imageComputedProperties, ['css', 'img']);
    setStyle(domNodes.image, imageStyle);
  }

  if (measures.bBox && domNodes.maskSvg) {
    setAttributes(domNodes.maskSvg, {
      viewBox: measures.bBox
    });
  }

  var containerStyle = getContainerStyle(style, imageData.opacity);
  setStyle(domNodes[id], containerStyle);
  var src = get(imageComputedProperties, 'uri'); //this was always like this (using _.get) and it looks like videoThumb images for wixapps explodes here since they dont have a uri -> no imageTransformProps

  var currentSrc = measures.imgSrc;
  setAttributes(domNodes[id], {
    'data-src': src
  }); //clear initial indication that the image src came from ssr render

  setAttributes(domNodes[id], {
    'data-has-ssr-src': ''
  });

  if (loadImage) {
    sendBiEvent(services.biService, envConsts, extendedImageInfo, {
      src: src,
      currentSrc: currentSrc
    }, imageComputedProperties);
    services.imageLoader.loadImage(domNodes[id], {
      screenHeight: measures.screenHeight,
      boundingRect: measures.boundingRect
    });
  }
}

export default {
  measure: measure,
  patch: patch
};
//# sourceMappingURL=imageLayout.js.map